module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_yakei-ccfb7abe59b5950d3b13b81d69d31bf7.jpg";